import p1 from '../assets/poste.jpg';
import p2 from '../assets/demolition.jpg';
import p3 from '../assets/solar.png';
import p4 from '../assets/ilumination.jpg';
export function Content(props) {

    return (
        <div className="content d-flex flex-column gap-3">

            <div className="presentation">
                <h2 className='font-montserrat-extra-bold'>PROINGEVALLE</h2>
                <p className='font-color-gray'>Proyectos de ingeniería del Valle</p>
                <p className='f-xl'>
                    Empresa situada en Santiago de Cali, Colombia. Dedicada al diseño y la ejecución de <strong>proyectos de ingenieria</strong>
                </p>
            </div>

            <div className='services d-flex'>

                <div className='project p1'>
                    <img src={p1} title="Montaje eléctrico" alt='Montaje eléctrico' className='object-pos-bot' />
                    <div className='info-project'>
                        <h3>Montajes eléctricos</h3>
                        <p className='font-color-gray'>
                            Servicios de instalación y mantenimiento de redes eléctricas domiciliarias, subestaciónes, plantas eléctricas, acometidas y sistemas de puesta a tierra [SPT]. Instalación de transformadores de baja, media y alta tensión.
                        </p>
                    </div>
                </div>

                <div className='project p2'>
                    <img src={p2} title="Obras Civiles" alt='Obras Civiles' />
                    <div className='info-project'>
                        <h3>Obras civiles</h3>
                        <p className='font-color-gray'>
                            Construcción vías, diseño de muros de contención, Construcción y diseño de unidades habitacionales.
                        </p>
                    </div>
                </div>

                <div className='project p2'>
                    <img src={p3} title="Sistemas fotovoltáicos" alt='Sistemas fotovoltáicos' />
                    <div className='info-project'>
                        <h3>Sistemas fotovoltáicos</h3>
                        <p className='font-color-gray'>
                            Instalación y conexión de sistemas de generación fotovoltáica.
                        </p>
                    </div>
                </div>

                <div className='project p1'>
                    <img src={p4} title="Iluminación industrial" alt='Iluminación industrial' className='object-pos-ilu' />
                    <div className='info-project'>
                        <h3>Iluminación industrial</h3>
                        <p className='font-color-gray'>
                            Instalación y conexión de iluminación LED, sensores, automatización y centralizado de circuitos.
                        </p>
                    </div>
                </div>

            </div>

            <div className='contact' id='contact'>
                <h3 className='font-montserrat-extra-bold'>¿Quieres contactarnos?</h3>
                <br />
                <div className='d-flex gap-3 flex-column contact-info bg-gray'>
                    <label className='font-color-gray'>Escríbenos directamente a :</label>
                    <div className='d-flex w-100'>
                        <a className='no-style font-montserrat-bold' href='mailto:proyectos@proingevalle.co'>proyectos@proingevalle.co</a>
                    </div>

                </div>

            </div >

            <div className='footer font-montserrat-bold'>
                © Copyright | Proingevalle 2023-2024
            </div>
        </div >
    );
}